export default {
  KYC_STATUS_FETCH: 'KYC_STATUS_FETCH',
  CUSTOMER_DATA_FETCH_TRIGGER: 'CUSTOMER_DATA_FETCH_TRIGGER',
  CUSTOMER_DATA_FETCH: 'CUSTOMER_DATA_FETCH',
  CUSTOMER_DATA_FETCH_FAILURE: 'CUSTOMER_DATA_FETCH_FAILURE',
  CUSTOMER_DETAILS_UPDATE_REQUIRED: 'CUSTOMER_DETAILS_UPDATE_REQUIRED',
  LOCALSTORAGE_SEEN_WELLS_MODAL_KEY: 'seen-wells-modal',
};
